<script>
import * as restfulService from '../../../services/restfulService'
import helpers from '@mixins/helper'
import {mapGetters} from 'vuex'

export default {
  mixins: [helpers],
  name: 'dashboard-valida-meus-dados-popup',
  data () {
    return {
      mostrarModal: false
    }
  },
  mounted () {
    this.buscarPopup()
  },
  computed: {
    ...mapGetters(['currentUser', 'isLogged']),
    isMobileSize: function () {
      return this.isMobile().any()
    },
    primeiroNome: function () {
      if (this.isLogged) {
        let nome = (this.currentUser.pessoa.nome.split(' ')[0] || '').toLowerCase()
        return nome.charAt(0).toUpperCase() + nome.slice(1)
      }
      return ''
    }
  },
  methods: {
    buscarPopup () {
      restfulService.get('pessoa', 'meus-dados')
        .then(response => {
          const nome = response.nome || ''
          const email = response.email || ''
          const telefone1 = response.pessoa_fisica.fone_residencial || ''
          const telefone2 = response.pessoa_fisica.fone_celular || ''
          const telefone3 = response.pessoa_fisica.fone_profissional || ''
          const cpf = response.pessoa_fisica.cpf || ''
          const rg = response.pessoa_fisica.rg_numero || ''
          const dataNascimento = response.pessoa_fisica.dt_nascimento || ''
          const sexo = response.pessoa_fisica.sexo || ''
          const cep = response.cep || ''
          const endereco = response.rua.length || ''
          const numero = response.numero || ''
          const bairro = response.bairro || ''
          const cidade = response.ref_cidade || ''
          const estadoCivil = response.pessoa_fisica.ref_estado_civil || ''
          const etnia = response.pessoa_fisica.ref_raca || ''
          const naturalidade = response.pessoa_fisica.ref_naturalidade || ''
          const nacionalidade = response.pessoa_fisica.ref_nacionalidade || ''
          const nomeMae = response.pessoa_fisica.nome_mae || ''

          let inconsistencias = 0

          if (nome.length <= 0 || email.length <= 0 || cpf.length !== 11 || rg.length <= 0 || dataNascimento.length !== 10 || !['M', 'F'].includes(sexo)) {
            inconsistencias++
          }

          if (telefone1.length <= 0 && telefone2.length <= 0 && telefone3.length <= 0) {
            inconsistencias++
          }

          if (cep.length !== 8 || endereco.length <= 0 || numero.length <= 0 || bairro.length <= 0 || cidade.length <= 0) {
            inconsistencias++
          }

          if (estadoCivil.length <= 0 || etnia.length <= 0 || naturalidade.length <= 0 || nacionalidade.length <= 0 || nomeMae.length <= 0) {
            inconsistencias++
          }

          if (inconsistencias > 0) {
            this.mostrarModal = true
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<template>
  <div>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '90%' : '40%'"
              persistent>
      <v-card class="popup-modal">
        <v-container>
          <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
            Atualização pendente
          </h3>
          <div class="text">
            <p :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
              Olá <strong>{{ primeiroNome }}</strong>, seus dados cadastrais estão incompletos. Para atualizar,
              <router-link :to="{name: 'minha-conta.dados-cadastrais'}"
                           style="display: inline-block">
                clique aqui
              </router-link>
              .
              <br><br>
              * Se após atualizar seus dados essa mensagem persistir, entre em contato com a Central de Atendimento para
              mais informações.
            </p>
          </div>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// ValidaMeusDadosPopup.vue?18004be0